export const BUILT_IN_VALIDATIONS_VALIDATION_ROUND_COUNTER_KEY: string = "validationRoundCounter";